import { useRef } from 'react'
import { Carousel } from '@hhgtech/hhg-components/mantine'
import { Box, BoxProps } from '@mantine/core'

import Autoplay from 'embla-carousel-autoplay'
import { HeroBanner } from 'interfaces/types'

import useStyles from './index.styles'
import { Item } from './item'

export type BannerItemProps = HeroBanner & BoxProps

const BannerItem = ({
  desktopBanner,
  mobileBanner,
  linkTo,
  title,
  ctaTitle,
  styles,
  ratio,
  className,
  classNames,
  dataTracking,
  hasLeavePageConfirm,
  keepRatio = true,
  onBannerLoad,
  listBanner = [],
  primaryColor,
  autoSlide,
  delayTime,
  ...boxProps
}: BannerItemProps) => {
  const autoplay = useRef(
    Autoplay({
      delay: delayTime || 7000,
      stopOnInteraction: false,
    }),
  )
  const listBannerFormat =
    listBanner.length > 0
      ? listBanner
      : [
          {
            desktopBanner,
            mobileBanner,
            ctaTitle,
            linkTo,
            title,
          },
        ]
  const { classes, cx } = useStyles(undefined, {
    name: 'CarePathHeroBannerBannerItemList',
    styles,
    classNames,
  })

  return (
    <Box
      className={cx(classes.root, className)}
      sx={() => ({
        overflow: 'hidden',
        img: {
          objectFit: 'cover',
          width: '100%',
          height: '100%',
        },
      })}
      {...boxProps}
    >
      <Box className={classes.wrapper}>
        <Carousel
          plugins={autoSlide ? [autoplay.current] : []}
          withControls={false}
          withIndicators={listBannerFormat.length > 1}
          loop
          styles={(theme) => ({
            indicator: {
              width: 8,
              height: 8,
              borderRadius: '50%',
              border: `1px solid ${theme.colors.neutral100}`,
              boxShadow: 'none',
              background: '#fff',
              opacity: 1,
              '&[data-active]': {
                borderColor: primaryColor,
                background: primaryColor,
              },
            },
          })}
        >
          {listBannerFormat.map((i, idx) => (
            <Carousel.Slide key={idx}>
              <Item
                i={i}
                dataTracking={dataTracking}
                keepRatio={keepRatio}
                ratio={ratio}
                listBannerLength={listBannerFormat.length}
              />
            </Carousel.Slide>
          ))}
        </Carousel>
      </Box>
    </Box>
  )
}

export { BannerItem }
